// extracted by mini-css-extract-plugin
export var body = "_bx-5";
export var closeButton = "_bx-f";
export var container = "_bx-1";
export var content = "_bx-2";
export var cta = "_bx-c";
export var ctaLabel = "_bx-b";
export var eyebrow = "_bx-3";
export var howTo = "_bx-6";
export var image = "_bx-e";
export var modal = "_bx-0";
export var socialButton = "_bx-d";
export var stepCard = "_bx-8";
export var stepLabel = "_bx-a";
export var stepNumber = "_bx-9";
export var steps = "_bx-7";
export var title = "_bx-4";